import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "परिचय ", key: "about" },
    { name: "संचालित पाठ्यक्रम", key: "courses" },
    { name: "संकाय सदस्य", key: "faculty" },
    { name: "समय सारिणी", key: "timetable" },
    { name: "सुविधाएं", key: "facilities" },
    { name: "सेमीनार/सम्मेलन/कार्यशाला", key: "events" },
    { name: "शोधच्छात्र", key: "researchScholars" },
    { name: "उपलब्धियां", key: "achievements" },
    { name: "सम्पर्क", key: "contact" }
];

// Content for each section, structured as an object
const departmentContent = {
    about: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >व्याकरण विभाग</h4>
            <p className="mb-3">सम्पूर्ण प्राणिमात्र का सर्वतोभावेन ऐहिक और पारलौकिक कल्याण भारतीय संस्कृति से ही सम्भव है। इस बात को आज का वैज्ञानिक समाज भी अनुभव करने लगा है। इस आर्ष संस्कृति का आधार है – संस्कृत वाङ्मय। हमारी आर्ष संस्कृति संस्कृत ग्रन्थों से उपनिबद्ध है, अतः संस्कृत और संस्कृति – ये दोनों परस्पर अवलम्बित होते हुए आज भी भारत की प्रतिष्ठा के रूप में प्रतिष्ठित हैं। जैसे कि कहा गया है –</p>
            <blockquote className="blockquote text-center my-4">
                <p className="mb-0">भारतस्य प्रतिष्ठे द्वे संस्कृत संस्कृतिस्तथा।</p>
            </blockquote>
            <p className="mb-3">इस प्रकार संस्कृति, संस्कृत पर आधारित है तथा यह संस्कृत भी पूर्णतः संस्कृत-व्याकरण में वर्णित है अर्थात् व्याकरण ही संस्कृत का व्युत्पादक है।</p>
            <p className="mb-3">व्याक्रियन्ते व्युत्पाद्यन्तेऽनेन शब्दाः (शब्दों का व्युत्पादन जिससे होता है, वह शास्त्र व्याकरण कहलाता है)। वि+आ+कृ+ल्युट् से व्याकरण शब्द निष्पन्न होता है। व्याकरण ही शब्दों के साधुत्व-असाधुत्व का प्रतिपादक है, अतः बिना व्याकरण के संस्कृत का याथातथ्येन ज्ञान करना असम्भव ही है। भाष्यकारानुसार "ज्ञानपूर्वकप्रयोगे धर्मः" तदनुसार इस देववाणी संस्कृत को जानकर उसी की तरह ही अमरता को प्राप्त करने के लिए व्याकरण एक सर्वश्रेष्ठ एवं लघु उपाय है। भारतीय संस्कृति के आधारभूत ग्रन्थ वेद हैं और वेद का सम्यक् ज्ञान व्याकरण के बिना नहीं हो सकता। अतः व्याकरण को वेद के छः अंगों में मुख कहा गया है। अतः व्याकरण का अध्ययन बिना किसी कारण धर्म मानकर करना चाहिए। यह संस्कृत व्याकरण भिन्न-भिन्न प्रवर्तकों के भेद से अनेक विध है, जिनमें से नौ व्याकरण अति प्रसिद्ध है। यद्यपि इन सभी व्याकरणों की शब्द व्युत्पादन क्रिया भिन्न-भिन्न है तथापि सभी का उद्देश्य तो एक मात्र परिनिष्ठित शब्द की सिद्धि है, व्याकरण जगत में शब्द स्फोट के नाम से शब्द ब्रह्म के रूप में प्रतिष्ठित होने के कारण नित्य, अनादि तथा एक हैं।</p>
            <p className="mb-3">व्याकरण की उत्पत्ति ब्रह्मा से हुई है। अतः धर्म-अर्थ-काम-मोक्ष की प्राप्ति हेतु मात्र एक राजपद्धति व्याकरण है। अतः यह पाठ्य है।</p>
            <p className="mb-3">भारतीय संस्कृति को समृद्ध करने की दिशा में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल का व्याकरण विभाग वर्ष 2018 से ही अक्षुण्ण योगदान देता आ रहा है। इस विभाग में मुख्यतः प्राच्य एवं नव्य व्याकरण विषय के शिक्षण के साथ-साथ संस्कृत सम्भाषण द्वारा छात्र एवं छात्राओं को सुसंस्कृत किया जाता है। अष्टाध्यायी के सूत्रों द्वारा इतिहास, भूगोल, यज्ञादि परम्परा का सम्यक् ज्ञान कराना व्याकरण विभाग के वैशिष्ट्य को दर्शाता है।</p>
            <h5 className="mt-4 mb-3 text-secondary">उद्देश्य –</h5>
            <ol className="mb-4">
                <li className="mb-2">अभिव्यक्ति की साधनभूत भाषा के व्याकरण के बोध के साथ लेखन, पठन एवं भाषण में प्रवीणता लाना।</li>
                <li className="mb-2">संस्कृत शास्त्र संरक्षण शास्त्र परम्परा के हस्तांतरण एवं यथार्थ सिद्धता में व्याकरण की भूमिका को स्पष्ट करना।</li>
                <li className="mb-2">व्याकरण सिद्धान्तों के वैज्ञानिक एवं सामाजिक निहितार्थों के आधुनिक बोध के साथ स्थापना हेतु।</li>
                <li className="mb-2">व्याकरण प्रयोग एवं भाषा वैज्ञानिक विश्लेषण के आधार पर छात्रों में भाषायी दक्षता लाना।</li>
                <li className="mb-2">संस्कृत भाषा के स्वरूप की सुरक्षा तथा भाषायी शुद्धता हेतु।</li>
                <li>व्याकरणिक तत्त्वों के ज्ञान हेतु।</li>
            </ol>
        </div>
    ),
    courses: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संचालित पाठ्यक्रम</h4>
            <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-book-fill me-2"></i> शास्त्री (व्याकरण)</li>
                <li className="mb-2"><i className="bi bi-book-fill me-2"></i> आचार्य (व्याकरण)</li>
                <li className="mb-2"><i className="bi bi-book-fill me-2"></i> विद्यावारिधि</li>
            </ul>
        </div>
    ),
    faculty: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संकाय सदस्य</h4>
            <h5 className="mb-3 text-secondary">कुल शिक्षक – 02 (नियमित)</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>फोटो</th>
                            <th>आचार्य का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "140px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. सुरेन्द्र पाल वत्स (विभागाध्यक्ष, व्याकरण).jpg")}
                                    alt="डॉ. सुरेन्द्र पाल"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. सुरेन्द्र पाल</td>
                            <td>विभागाध्यक्ष, सह-आचार्य</td>
                            <td>Ph.D., NET</td>
                            <td>9896335373</td>
                            <td><a href="mailto:hodvyakaran@mvsu.ac.in">hodvyakaran@mvsu.ac.in</a></td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src={require("../assets/Photos/डॉ. शर्मिला (व्याकरण विभाग).jpg")}
                                    alt="डॉ. शर्मिला"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. शर्मिला</td>
                            <td>सहायक आचार्या</td>
                            <td>M.Phil., Ph.D., NET, JRF</td>
                            <td>9254640788</td>
                            <td><a href="mailto:omsharmila88@gmail.com">omsharmila88@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    timetable: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >समय सारिणी</h4>
            <p className="text-muted">समय सारिणी शीघ्र उपलब्ध होगी।</p>
        </div>
    ),
    facilities: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सुविधाएं</h4>
            <ol className="mb-3">
                <li className="mb-2">छात्रों को वैषयिक ज्ञान के साथ संस्कृत सम्भाषण कराया जाता है।</li>
                <li className="mb-2">विविध प्रतियोगी परीक्षाओं का प्रशिक्षण प्रदान किया जाता है, जैसे – यू.जी.सी. नेट परीक्षा, CTET, B.Ed., T.G.T (Sanskrit), P.G.T (Sanskrit) हेतु प्रशिक्षण इत्यादि।</li>
                <li className="mb-2">मानसिक ज्ञान संवर्धन हेतु समय-समय पर विविध प्रतियोगिताओं का आयोजन करवाया जाता है।</li>
            </ol>
        </div>
    ),
    events: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सेमीनार/सम्मेलन/कार्यशाला</h4>
            <p className="text-muted">सेमीनार/सम्मेलन/कार्यशाला संबंधी जानकारी शीघ्र उपलब्ध होगी।</p>
        </div>
    ),
    researchScholars: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >शोधच्छात्र</h4>
            <h5 className="mb-3 text-secondary">विद्यावारिधि उपाधि हेतु पंजीकृत छात्रों की विवरणी –</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">गवेषक</th>
                            <th scope="col">पर्यवेक्षक</th>
                            <th scope="col">विषय</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>रीशु</td>
                            <td>डॉ. सुरेन्द्र पाल</td>
                            <td>(विषय शीघ्र उपलब्ध होगा)</td>
                        </tr>
                        <tr>
                            <td>राहुल</td>
                            <td>डॉ. सुरेन्द्र पाल</td>
                            <td>(विषय शीघ्र उपलब्ध होगा)</td>
                        </tr>
                        <tr>
                            <td>अनिल कुमार</td>
                            <td>डॉ. सुरेन्द्र पाल</td>
                            <td>(विषय शीघ्र उपलब्ध होगा)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    achievements: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >उपलब्धियां</h4>
            <h5 className="mb-3 text-secondary">रोजगार प्राप्त छात्र:</h5>
            <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> श्रीमती मोनिका (हरियाणा शिक्षा विभाग में संस्कृत प्राध्यापक पद पर कार्यरत)</li>
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> सुश्री रीशु (हरियाणा शिक्षा विभाग में संस्कृत प्राध्यापक पद पर कार्यरत)</li>
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> सुश्री माफी (उत्तर-प्रदेश सरकार में डाक विभाग में कार्यरत)</li>
            </ul>
            <h5 className="mt-4 mb-3 text-secondary">यू.जी.सी. नेट उत्तीर्ण छात्र:</h5>
            <ol className="list-unstyled">
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> श्रीमती मोनिका</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> सुश्री कृष्णा</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> सुश्री रीटा</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> सुश्री शिवानी</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> श्री विकास कुमार</li>
            </ol>
            <h5 className="mt-4 mb-3 text-secondary">जे.आर.एफ. उत्तीर्ण छात्र:</h5>
            <ol className="list-unstyled">
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> सुश्री पूनम देवी</li>
                <li className="mb-2"><i className="bi bi-check-circle-fill text-success me-2"></i> श्री नवीन शर्मा</li>
            </ol>
        </div>
    ),
    contact: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सम्पर्क</h4>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">क्र.</th>
                            <th scope="col">नाम</th>
                            <th scope="col">पद</th>
                            <th scope="col">सम्पर्क सूत्र</th>
                            <th scope="col">ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>डॉ. सुरेन्द्र पाल</td>
                            <td>विभागाध्यक्ष, सह-आचार्य</td>
                            <td>9896335373</td>
                            <td><a href="mailto:hodvyakaran@mvsu.ac.in">hodvyakaran@mvsu.ac.in</a></td>
                        </tr>
                        <tr>
                            <td>2.</td>
                            <td>डॉ. शर्मिला</td>
                            <td>सहायक आचार्या</td>
                            <td>9254640788</td>
                            <td><a href="mailto:omsharmila88@gmail.com">omsharmila88@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* Moved the non-academic staff table here as a separate table */}
            <h5 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >गैर-शैक्षणिक कर्मचारी संपर्क:</h5>
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">क्र.</th>
                            <th scope="col">नाम</th>
                            <th scope="col">पद</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>श्री सीताराम</td>
                            <td>क्लर्क (HKRN)</td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    )
};

export default function GrammarDepartments() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0); // State to manage active sidebar item

    const handleItemClick = (index) => {
        setActiveIndex(index);
        // Hide sidebar on small screens after an item is clicked
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    // Get the key for the currently active department to fetch its content
    const activeDepartmentKey = departments[activeIndex].key;

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>


            {/* Sidebar (Collapsible on small screens) */}
            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">व्याकरण विभाग</h5>
                <div className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept, index) => (
                        <p
                            key={dept.key}
                            className={`mb-2 p-2 rounded small cursor-pointer shadow-sm ${activeIndex === index ? "text-white" : "bg-light text-dark hover-effect"
                                }`}
                            onClick={() => handleItemClick(index)}
                            style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                backgroundColor: activeIndex === index ? "#77236b" : undefined,
                                fontWeight: activeIndex === index ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {departmentContent[activeDepartmentKey]}
            </main>

            {/* Optional: Add a simple CSS for hover effect */}
            <style jsx>{`
                .hover-effect:hover {
                    background-color: #e2e6ea !important;
                    color: #000 !important;
                }
            `}</style>
        </div>
    );
}